// GENERATED by scripts/sync-katha-indexes.cjs. Do not edit this file manually.
// Add or update a story JSON and run: npm run sync:katha
import storyIndex0 from './story-indexes/shri-krishna-bal-leela.json';
import storyIndex1 from './story-indexes/braj-ke-bhakt-part-1.json';
import storyIndex2 from './story-indexes/braj-ke-bhakt-part-2.json';
import storyIndex3 from './story-indexes/braj-ke-bhakt-part-3.json';

const storyIndexes = {
  "shri-krishna-bal-leela": storyIndex0,
  "braj-ke-bhakt-part-1": storyIndex1,
  "braj-ke-bhakt-part-2": storyIndex2,
  "braj-ke-bhakt-part-3": storyIndex3
};
export default storyIndexes;
